<template>
  <div class="board__list-line" @dblclick="showAppointment(item.id)">
    <v-row class="pl-12 py-2" no-gutters>
      <v-col class="d-flex align-center" cols="10">
        <BoardItemIcon :type="item.type" />

        <span class="d-block subtitle-2 mr-2 grey--text text--darken-3">
          {{ dateFormat(item.date) }}
        </span>

        <span class="d-block grey--text caption mr-2">#{{ item.code }}</span>

        <BoardItemRealties :realties="item.realty_codes" />

        <BoardLinePersons :host="item.host_name" :visitor="item.visitor_name" />
      </v-col>
      <v-col class="text-right" cols="2">
        <MenuAppointment :appointment="item" />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'

import BoardItemIcon from '../../BoardItemIcon'
import BoardLinePersons from '../line/BoardLinePersons'
import BoardItemRealties from '../../BoardItemRealties'
import MenuAppointment from '@/components/appointment/MenuAppointment'
import { catalogDate } from '@/util/catalog'

export default {
  name: 'BoardItemTitle',

  components: {
    BoardItemIcon,
    BoardLinePersons,
    BoardItemRealties,
    MenuAppointment,
  },

  props: {
    item: {
      type: Object,
      required: true,
    },

    column: {
      type: String,
      required: true,
    },
  },

  data() {
    return {
      dateFormat: catalogDate,
    }
  },

  methods: {
    ...mapMutations(['setIsDrawerOpen']),
    ...mapActions(['fetchAppointment']),

    showAppointment(id) {
      this.fetchAppointment(id)
      this.setIsDrawerOpen(true)
    },
  },
}
</script>
